import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Stack } from 'syf-component-library/ui/spacing';
import { Small } from 'syf-component-library/ui/typography';
import { PAGE_FUNCTION, PAGE_NAME, PaymentMethodToPageSubFunctionText } from '../../../../const/analytics';
import { CHECKING, CREDIT_CARD, PINLESS_DEBIT_CARD, SAVINGS } from '../../../../const/paymentMedium';
import MainContext from '../../../../Context';
import { getDisclosureTextFromProductType } from '../../../../helpers';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import usePaymentMethodMachine from '../../../../hooks/machines/usePaymentMethodMachine';
import PaymentMethodTypeSelectorWrapper from '../PaymentMethodTypeSelector/PaymentMethodTypeSelectorWrapper';
import CheckingSavingsAccountForm from './CheckingSavingsAccountForm';
import DebitCreditAccountForm from './DebitCreditAccountForm';
const PaymentMethodForm = ({ className, errorMessage, setFormErrorMessage, setIsSubmitting }) => {
    const { featureFlags, triggerAnalyticsEvent } = useContext(MainContext);
    const [apiMachine] = useApiMachine();
    const { data: accountSummary } = apiMachine.context.accountSummaryQueryResult;
    const productType = accountSummary.product.type;
    const [paymentMethodMachine, sendToPaymentMethod] = usePaymentMethodMachine();
    // TODO: Remove this when we deprecate the isManagePaymentMethodsEnabled featureFlag
    const legacyIsChecking = paymentMethodMachine.matches('addNewCheckingAccount');
    const legacyIsSavings = paymentMethodMachine.matches('addNewSavingsAccount');
    const legacyIsDebit = paymentMethodMachine.matches('addNewDebitCard');
    const legacyIsCredit = paymentMethodMachine.matches('addNewCreditCard');
    // End Todo
    const isChecking = legacyIsChecking ||
        paymentMethodMachine.matches('addPaymentMethod.addNewCheckingAccount');
    const isSavings = legacyIsSavings ||
        paymentMethodMachine.matches('addPaymentMethod.addNewSavingsAccount');
    const isDebit = legacyIsDebit ||
        paymentMethodMachine.matches('addPaymentMethod.addNewDebitCard');
    const isCredit = legacyIsCredit ||
        paymentMethodMachine.matches('addPaymentMethod.addNewCreditCard');
    const isBankAccount = isChecking || isSavings;
    const isCardAccount = isDebit || isCredit;
    const [paymentMethodType] = [
        [SAVINGS, isSavings],
        [CHECKING, isChecking],
        [PINLESS_DEBIT_CARD, isDebit],
        [CREDIT_CARD, isCredit]
    ].find(([, matches]) => {
        return matches;
    });
    const [primaryDisclosureText, secondaryDisclosureText] = getDisclosureTextFromProductType(productType);
    const handlePaymentMethodTypeChange = (value) => {
        switch (value) {
            case CHECKING:
                sendToPaymentMethod({ type: 'GO_TO_CHECKING' });
                break;
            case SAVINGS:
                sendToPaymentMethod({ type: 'GO_TO_SAVINGS' });
                break;
            case PINLESS_DEBIT_CARD:
                sendToPaymentMethod({ type: 'GO_TO_DEBIT' });
                break;
            case CREDIT_CARD:
                sendToPaymentMethod({ type: 'GO_TO_CREDIT' });
                break;
            default:
                break;
        }
        setFormErrorMessage('');
        const pageSubFunctionText = PaymentMethodToPageSubFunctionText[value];
        triggerAnalyticsEvent({
            pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS,
            pageSubFunction: pageSubFunctionText,
            pageName: PAGE_NAME.START
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(PaymentMethodTypeSelectorWrapper, { errorMessage: errorMessage, featureFlags: featureFlags, handlePaymentMethodTypeChange: handlePaymentMethodTypeChange, paymentMethodType: paymentMethodType, productType: productType }), _jsx(Stack, { size: "large" }), isBankAccount ? (_jsx(CheckingSavingsAccountForm, { className: className, setFormErrorMessage: setFormErrorMessage, setIsSubmitting: setIsSubmitting })) : null, isCardAccount ? (_jsx(DebitCreditAccountForm, { className: className, setFormErrorMessage: setFormErrorMessage, setIsSubmitting: setIsSubmitting })) : null, _jsx(Small, Object.assign({ "data-cy": "payment-method-primary-disclosure-text", id: "primaryDisclosureText" }, { children: primaryDisclosureText })), _jsx("br", {}), _jsx(Small, Object.assign({ "data-cy": "payment-method-secondary-disclosure-text", id: "secondaryDisclosureText" }, { children: secondaryDisclosureText }))] }));
};
export default PaymentMethodForm;
